import { FC, ReactNode } from 'react';
import { FormattedMessage } from 'dibs-react-intl';

import { Button } from 'dibs-elements/exports/Button';

import styles from './PdpSharedAuctionsWatch.scss';

type Props = {
    buttonSize: 'small' | 'medium' | 'large';
    heartIcon: ReactNode;
    onClick?: () => void;
    isLoading?: boolean;
    isFavorited?: boolean;
    setIsHoverClass?: (showHover: boolean) => void;
};

const PdpSharedAuctionsWatchWrapper: FC<Props> = ({
    heartIcon,
    buttonSize,
    onClick,
    isLoading,
    setIsHoverClass,
    isFavorited,
}) => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.header}>
                <FormattedMessage
                    id="PdpSharedAuctionsWatchWrapper.header"
                    defaultMessage="Get Updates on this Auction"
                />
            </div>
            {/* disabled onMouseOver/onMouseOut must be accompanied by onFocus/onBlur */}
            {/* eslint-disable-next-line jsx-a11y/mouse-events-have-key-events*/}
            <div
                className={styles.buttonWrapper}
                onMouseOver={() => setIsHoverClass?.(true)}
                onMouseOut={() => setIsHoverClass?.(false)}
            >
                <Button
                    size={buttonSize}
                    className={styles.button}
                    dataTn="auction-watch-btn"
                    type="secondary"
                    onClick={onClick}
                    disabled={isLoading}
                >
                    {heartIcon}
                    <div className={styles.labelWrapper}>
                        {isFavorited ? (
                            <FormattedMessage
                                id="PdpSharedAuctionsWatchWrapper.watching"
                                defaultMessage="Watching"
                            />
                        ) : (
                            <FormattedMessage
                                id="PdpSharedAuctionsWatchWrapper.watch"
                                defaultMessage="Watch"
                            />
                        )}
                    </div>
                </Button>
            </div>
        </div>
    );
};

export default PdpSharedAuctionsWatchWrapper;
